// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9319bd54","455":"51db2fa2","977":"ac165212"}[chunkId] + ".chunk.js";
};